/**
 * Text the attestation flows show and record (PLA-1110).
 *
 * The legal text is flattened from the parsed docs/legal/ markdown so the API
 * stores exactly what the modal renders (Legal-only HTML comments are already
 * stripped by the parser). The goals commitment statement is what the reminder
 * modal shows above the goal list.
 */

import { getLegalDoc, type LegalDoc, type LegalDocId } from './legalContent';

export const GOALS_COMMITMENT_TEXT =
  'I have reviewed the documentation quality goals my organization has set for these chief complaints, and I commit to working toward them.';

/** Plain-text rendering of a legal document, block by block, as shown. */
export function legalDocPlainText(doc: LegalDoc): string {
  const lines: string[] = [doc.title];
  if (doc.subtitle) lines.push(doc.subtitle);
  for (const block of doc.blocks) {
    switch (block.kind) {
      case 'list':
        lines.push(block.items.map((item) => `- ${item}`).join('\n'));
        break;
      default:
        lines.push(block.text);
    }
  }
  return lines.join('\n\n');
}

export function legalDocText(id: LegalDocId): string {
  const doc = getLegalDoc(id);
  return doc ? legalDocPlainText(doc) : '';
}
